/* eslint-disable @typescript-eslint/no-explicit-any */
import { ClassNameMap } from "@material-ui/styles";
import { ToastOptions } from "react-toastify";

export interface MUI_ClassStyles {
  classes?: ClassNameMap<string>;
}

export interface GridItemProps {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export interface ButtonProps {
  color:
    | "primary"
    | "info"
    | "success"
    | "warning"
    | "danger"
    | "rose"
    | "white"
    | "twitter"
    | "facebook"
    | "google"
    | "linkedin"
    | "pinterest"
    | "youtube"
    | "tumblr"
    | "github"
    | "behance"
    | "dribbble"
    | "reddit"
    | "transparent";
  size?: "sm" | "lg";
  simple?: boolean;
  round?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  block?: boolean;
  link?: boolean;
  justIcon?: boolean;
  muiClasses?: any;
  onClick?: () => void;
}

export const ProfileEnum = {
  SOW: "SOW",
  SOWADM: "SOWADM",
  WORKER: "WORKER",
};

export const RolesEnum = {
  ACCESS_TO_OPERATION_BY_EXCEPTION_APPROVER:
    "Access To Operation By Exception Approver",
  ADMIN_SUPPORT: "Admin Support",
  COMPANY_REPRESENTATIVE: "Company Representative",
  CONFIDENTIAL_DATA_OBSERVER_MANAGER: "Confidential Data Observer Manager",
  HEALTH_SME: "Health SME",
  HUMAN_RESOURCES_ORG_DATA_STRUCTURE: "Human Resources - Org Data Structure",
  HUMAN_RESOURCES_TIME_ATTENDANCE: "Human Resources - Time & Attendance",
  SAFETY_SME: "Safety SME",
  SUPPLIER_ONBOARDING_PERSONNEL: "Supplier Onboarding Personnel",
  SUPPLIER_COMPANY_REP: "Supplier Company Rep",
  BUYER: "buyer",
  APPROVER: "Approver",
  EHS: "ehs",
  HR: "hr",
  STRATESYS: "stratesys",
  UVERIFY: "uverify",
  UVERIFY_ANGLO: "uverifyAnglo",
  INSURANCE: "insurance",
  LEGAL: "legal",
  SUPER_USER: "superUser",
  SUPPLIER: "supplier",
  SUPPLIER_PRIMARY_CONTACT: "suppliers - primary contact",
  MANUAL_VALIDATION: "manualValidation",
  SUPER_USER_APPROVE_ACTIVITY: "Super Approve Activity",
  CREATE_RELEASE_NOTES: "Create Release Notes",
  DOCUMENTATION: "Documentation",
  NEW_HEADER_UVERIFY: "New Header UVerify",
  NEW_ANALYSIS_MODAL: "New Analysis Modal",
  USERS_MANAGER: "Users manager",
};

export const StatusBadgeMapping: {
  [key: string]: {
    color: string;
    text: string;
    loading?: boolean;
  };
} = {
  Pending: { color: "warning", text: "Pending" },
  "Pending Approval": { color: "warning", text: "Pending Approval" },
  "Response Pending Approval": {
    color: "warning",
    text: "Response Pending Approval",
  },
  "Approval Paused": { color: "warning", text: "Approval Paused" },
  "Pending Response": { color: "warning", text: "Pending Response" },
  Blocked: { color: "danger", text: "Blocked" },
  Withdrawn: { color: "danger", text: "Withdrawn" },
  "Response Rejected": { color: "danger", text: "Response Rejected" },
  Rejected: { color: "danger", text: "Rejected" },
  Closed: { color: "danger", text: "Closed" },
  Canceled: { color: "danger", text: "Canceled" },
  Approved: { color: "success", text: "Approved" },
  Declined: { color: "warning", text: "Declined" },
  Completed: { color: "success", text: "Completed" },
  Activated: { color: "success", text: "Activated" },
  Active: { color: "success", text: "Active" },
  Confirmed: { color: "success", text: "Confirmed" },
  Granted: { color: "success", text: "Granted" },
  Draft: { color: "info", text: "Draft" },
  Loading: { color: "info", text: "Loading" },
  FINISHED: { color: "success", text: "Finished" },
  FINISH: { color: "info", text: "Finish" },
  APPROVED: { color: "success", text: "Approved" },
  REJECTED: { color: "danger", text: "Rejected" },
  "Documents Uploaded": { color: "info", text: "Documents Uploaded" },
  "Waiting Documents": { color: "info", text: "Waiting Documents" },
  COMPLETED: { color: "success", text: "COMPLETED" },
  PENDING: { color: "warning", text: "PENDING" },
  CLOSED: { color: "danger", text: "Closed" },
  WAITING_FOR_DOWNLOAD: { color: "info", text: "Waiting Download" },
  WAITING_FOR_APPROVAL: { color: "info", text: "Waiting Approval" },
  MANUAL_VALIDATION: { color: "info", text: "Manual Validation" },
  SUPPLIER_DOWNLOADED: { color: "info", text: "Supplier Downloaded" },
  PREPARING_FOR_PROCESS: { color: "info", text: "Preparing for Process" },
  WAITING_PROCESS: { color: "info", text: "Processing", loading: true },
  "PENDING SYNC SOW": { color: "info", text: "Pending Sync SOW" },
  "INTEGRATION PENDING": { color: "info", text: "Integration Pending" },
  VALIDATION_PENDING: { color: "info", text: "Validation Pending" },
  NOT_HOMOLOGATED: { color: "danger", text: "Not Homologated" },
  FINALIZADO: { color: "danger", text: "FINALIZADO" },
  HOMOLOGADO: { color: "success", text: "Homologated" },
  HOMOLOGATED: { color: "success", text: "Homologated" },
  "HOMOLOGADO MANUALMENTE": { color: "success", text: "Manually Approved" },
  "NÃO HOMOLOGADO": { color: "danger", text: "Not Homologated" },
  Inactive: { color: "danger", text: "Inactive" },
  "Invite Sent": { color: "info", text: "Invite Sent" },
  "Invite Expired": { color: "warning", text: "Invite Expired" },
  buyer: { color: "rose", text: "buyer" },
  supplier: { color: "gray", text: "supplier" },
  "suppliers - primary contact": { color: "primary", text: "supplier primary" },
  "Not Validated": { color: "danger", text: "Not Validated" },
  Passed: { color: "success", text: "Passed Validation" },
  Failed: { color: "danger", text: "Failed Validation" },
  UPLOADING_DOCUMENTS: { color: "info", text: "Uploading Documents" },
  "Manually Approved": { color: "success", text: "Manually Approved" },
  READ_ONLY: { color: "info", text: "Read only" },
  WAITING_FOR_EXTERNAL_SERVICE: {
    color: "info",
    text: "Waiting for External Service",
  },
  CANCELED: { color: "danger", text: "Canceled" },
  ACTIVE: { color: "success", text: "Active" },
};

export const StatusIconMapping: {
  [key: string]: string;
} = {
  Pending: "pending",
  "Pending Approval": "pending",
  "Response Pending Approval": "pending",
  "Approval Paused": "pending",
  "Pending Response": "pending",
  Blocked: "close",
  Withdrawn: "close",
  "Response Rejected": "close",
  Rejected: "close",
  Closed: "close",
  Canceled: "close",
  Approved: "done",
  Completed: "done",
  Activated: "done",
  Active: "done",
  Confirmed: "done",
  Granted: "done",
  Draft: "pending",
  Loading: "pending",
  FINISHED: "done",
  FINISH: "done",
  APPROVED: "done",
  REJECTED: "close",
  "Documents Uploaded": "pending",
  "Waiting Documents": "pending",
  WAITING_FOR_DOWNLOAD: "pending",
  WAITING_FOR_APPROVAL: "pending",
  MANUAL_VALIDATION: "pending",
  SUPPLIER_DOWNLOADED: "pending",
  PREPARING_FOR_PROCESS: "pending",
  WAITING_PROCESS: "pending",
  VALIDATION_PENDING: "pending",
  NOT_HOMOLOGATED: "close",
  HOMOLOGADO: "done",
  HOMOLOGATED: "done",
  "HOMOLOGADO MANUALMENTE": "done",
  "NÃO HOMOLOGADO": "close",
};

export const StatusColorEnum = {
  COMPLETED: { color: "info", msg: "Puede ser analizado" },
  PENDING: { color: "warning", msg: "Pendiente de Envío" },
  APPROVED: { color: "success", msg: "Aprobado" },
  UNAPPROVED: { color: "danger", msg: "No Aprobado" },
  LOADING: { color: "", msg: "Loading..." },
  CANCELED: { color: "", msg: "Canceled" },
};

export const WorkItemStatusEnum = {
  APROVADO: "APROVADO",
  REJEITADO: "REJEITADO",
  REJEITADO_MANUALMENTE: "REJEITADO MANUALMENTE",
  HOMOLOGADO_MANUALMENTE: "HOMOLOGADO MANUALMENTE",
  MANUALLY_HOMOLOGATED: "MANUALLY_HOMOLOGATED",
  NOT_HOMOLOGATED: "NOT_HOMOLOGATED",
  FINALIZAR: "FINALIZAR",
  FINISH: "FINISH",
  PENDING: "PENDING",
  CREATED: "CREATED",
  COMPLETED: "Completed",
};

export const WorkItemResultEnum = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN PROGRESS",
  APROVADO_MANUALMENTE: "APROVADO MANUALMENTE",
  REJEITADO_MANUALMENTE: "REJEITADO MANUALMENTE",
  HOMOLOGADO: "HOMOLOGADO",
  HOMOLOGATED: "HOMOLOGATED",
  NAO_HOMOLOGADO: "NÃO HOMOLOGADO",
  HOMOLOGADO_MANUALMENTE: "HOMOLOGADO MANUALMENTE",
  MANUALLY_HOMOLOGATED: "MANUALLY_HOMOLOGATED",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  Not_Approved: "Not Approved",
  Approved: "Approved",
};

export const ProfileStatusEnum = {
  CONFIRMED: "Confirmed",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING_APPROVAL: "Pending Approval",
  PENDING: "Pending",
};

export const ExtractTypeEnum = {
  INVALIDO: "El proceso no se puede completar, documento inválido o extracción",
  CAMPO_NAO_ENCONTRADO: "CAMPO NO ENCONTRADO",
  DOCUMENTO_INVALIDO: "DOCUMENTO INVÁLIDO",
  TIPO_DOCUMENTO: "TIPO DE DOCUMENTO",
  RULE_FIELD_NOT_FOUND: "Field not found",
  PREENCHIDO: "Preenchido",
  NAO_PREENCHIDO: "Não Preenchido",
  INVALID_DOCUMENT: "Invalid document",
  DOCUMENTO_PREENCHIDO: "Valor do Documento Preenchido",
  ATTACHMENTS_COUNT: "Attachments count",
  INVALID_DATE: "Invalid Date",
  FIELDGLASS_UNAVAILABLE:
    "Fieldglass is currently unavailable, please try again later.",
  DOCUMENT_USED_AGAIN: "This type of document cannot be used again",
  WORKERSNAMES: "workersNames",
  RULEFIELD_NOT_FOUND: "Rulefieldnotfound",
};

export const SheFileStatusEnum = {
  PENDING_APPROVE: "PENDING_APPROVE",
  APPROVED: "APPROVED",
  REJECT: "REJECT",
  INVALID_STATUS: "INVALID_STATUS",
};

export const SowStatusEnum = {
  APPROVED: "Approved",
  ACTIVE: "Active",
  APPROVAL_PAUSED: "Approval Paused",
  DRAFT: "Draft",
  PENDING_APPROVAL: "Pending Approval",
  PENDING_RESPONSE: "Pending Response",
  RESPONSE_PENDING_APPROVAL: "Response Pending Approval",
  CLOSED: "Closed",
  RESPONSE_REJECTED: "Response Rejected",
};

export const ActionTypes = {
  HISTORY_DOCUMENTS: "history_documents",
  APPROVE_ACTIVITY: "approve_activity",
  SUPER_APPROVE_ACTIVITY: "super_approve_activity",
  UPLOAD_DOCUMENTS: "upload_documents",
  DOWNLOAD_DOCUMENTS: "download_documents",
  REASON: "reason",
  RESET_ACTIVITY: "reset_activity",
  LOG_SYSTEM: "log_system",
  PROCESS_ACTIVITY: "process_activity",
  DELETE_ACTIVITY: "delete_activity",
  REVIEW_ACTIVITY: "review_activity",
  REOPEN: "reopen_activity",
  ANALYSIS: "analysis",
};

export const SensitiveDataStatusEnum = {
  PENDING_DATA: "Pending Data",
  PENDING_HR_FIELDS: "Pending HR Fields",
  PENDING_OREP: "Pending OREP",
  PENDING_APPROVAL: "Pending Approval",
  COMPLETED: "Completed",
};

export const ActivityItemStatusEnum = {
  REJECTED: "Rejected",
  APPROVED: "Approved",
  PENDING: "Pending",
  COMPLETED: "Completed",
  HOMOLOGATED: "Homologated",
  UPLOADING_DOCUMENTS: "Uploading Documents",
  UPLOADING_DOCUMENTS_BUYER: "UPLOADING_DOCUMENTS_BUYER",
  UPLOADING_DOCUMENTS_SUPPLIER: "UPLOADING_DOCUMENTS_SUPPLIER",
  READ_ONLY: "READ_ONLY",
  CANCELED: "Canceled",
};

export const FlowStepsStatusEnum = {
  SUPPLIER_UPLOADING_DOCUMENTS: "SUPPLIER_UPLOADING_DOCUMENTS",
  CHANGE_ACTIVITY_STATUS: "CHANGE_ACTIVITY_STATUS",
};

export const ActivityItemValidationStatusEnum = {
  SUPPLIER_DOWNLOAD: "SUPPLIER_DOWNLOAD",
  SUPPLIER_DOWNLOADED: "SUPPLIER_DOWNLOADED",
  WAITING_FOR_DOWNLOAD: "WAITING_FOR_DOWNLOAD",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  PREPARING_FOR_PROCESS: "PREPARING_FOR_PROCESS",
  MANUAL_VALIDATION: "MANUAL_VALIDATION",
  WAITING_DOCUMENTS: "Waiting Documents",
  WAITING_DOCUMENTS_OLD: "WAITING_DOCUMENTS",
  FINISHED: "FINISHED",
  WAITING_PROCESS: "WAITING_PROCESS",
  VALIDATION_PENDING: "VALIDATION PENDING",
  NOT_HOMOLOGATED: "NOT_HOMOLOGATED",
  SUPPLIER_UPLOADING_DOCUMENTS: "SUPPLIER_UPLOADING_DOCUMENTS",
  NOT_HOMOLOGATED_BR: "NÃO HOMOLOGADO",
  WAITING_FOR_UPDATE: "WAITING_FOR_UPDATE",
};

export const stepNameMap: { [key: string]: string } = {
  CHANGE_ACTIVITY_STATUS: "Upload document",
  SEND_EMAIL_SUPPLIER: "Send Email for supplier",
  SUPPLIER_DOWNLOAD: "Supplier download",
  SEND_MAIL_FOR_GROUPS: "Send email for groups",
  UPLOAD_DOCUMENT_ON_FIELDGLASS: "Upload document on FieldGlass",
  COMPLETE_SFG_ACTIVITY: "Complete activity on FieldGlass",
  MANUAL_VALIDATION: "Manual Validation",
  SEND_CONDITIONAL_MAIL: "Send Conditional Email",
  CHECK_MANUAL_VALIDATION_RESULT: "Check Manual Validation Result",
};

export const SubjectStatusLogSystemEnum: Record<
  ISubjectStatusLogSystem,
  string
> = {
  DOWNLOAD_FILE_FROM_FIELDGLASS:
    "react-table-status-download-file-from-fieldglass",
  UPLOAD_FILE_FROM_UVERIFY: "react-table-status-upload-file-from-uverify",
  DOCUMENT_EXTRACTION_COMPLETED_SUCCESS:
    "react-table-status-document-extraction-completed-success",
  DOCUMENT_EXTRACTION_COMPLETED_FAIL:
    "react-table-status-document-extraction-completed-fail",
  ANALISYS_COMPLETED_SUCCESS: "react-table-status-analisys-completed-success",
  ANALISYS_COMPLETED_FAIL: "react-table-status-analisys-completed-fail",
  MANUAL_APPROVAL: "react-table-status-manual-approval",
  MANUAL_REJECTION: "react-table-status-manual-rejection",
  MANUAL_APPROVAL_BY_SUPERUSER:
    "react-table-status-manual-approval-by-superuser",
  MANUAL_REJECTION_BY_SUPERUSER:
    "react-table-status-manual-rejection-by-superuser",
  DOWNLOAD_FILE_FROM_UVERIFY: "react-table-status-download-file-from-uverify",
  COMPLETE_ACTIVITY_ITEM_FIELDGLASS:
    "react-table-status-complete-activity-item-fieldglass",
  REOPEN_ACTIVITY_ITEM_FIELDGLASS:
    "react-table-status-reopen-activity-item-fieldglass",
  EMAIL_SENT: "react-table-status-email-sent",
  SUPPLIER_DOWNLOAD: "react-table-status-supplier-download",
  SUPPLIER_DOWNLOADED: "react-table-status-supplier-downloaded",
  WAITING_FOR_DOWNLOAD: "react-table-status-waiting-for-download",
  REJECTED: "react-table-status-rejected",
  APPROVED: "react-table-status-approved",
  WAITING_FOR_APPROVAL: "react-table-status-waiting-for-approval",
  PREPARING_FOR_PROCESS: "react-table-status-preparing-for-process",
  MANUAL_VALIDATION: "react-table-status-manual-validation",
  WAITING_DOCUMENTS: "react-table-status-waiting-documents",
  FINISHED: "react-table-status-finished",
  WAITING_PROCESS: "react-table-status-waiting-process",
  VALIDATION_PENDING: "react-table-status-validation-pending",
  NOT_HOMOLOGATED: "react-table-status-not-homologated",
  SUPPLIER_UPLOADING_DOCUMENTS:
    "react-table-status-supplier-uploading-documents",
  NOT_HOMOLOGATED_BR: "react-table-status-not-homologated-br",
  RESET_VALIDATION_FIELDS: "react-table-status-reset-validation-fields",
  CHANGE_STATUS: "react-table-status-change-status",
  DELETE_ATTACHMENT: "react-table-status-delete-attachment",
  WORKFLOW_INITIATED: "react-table-status-workflow-initiated",
  FILE_UPLOADED: "react-table-status-file-uploaded",
  SEND_COMPLETE_QUEUE_PROCESS: "react-table-status-send-complete-queue-process",
  MANUAL_REOPEN_BY_SUPERUSER: "react-table-status-manual-reopen-by-superuser",
  FILE_UPLOADED_AZURE: "react-table-status-file-uploaded-azure",
  DOCUMENT_DEACTIVATED: "react-table-status-document-deactivated",
  AUTOMATIC_APPROVAL: "react-table-status-automatic-approval",
  AUTOMATIC_REJECTION: "react-table-status-automatic-rejection",
  RETRY_QUEUE_PROCESS_COMPLETE_ATV:
    "react-table-status-retry_queue_process_complete_atv",
  RETRY_QUEUE_PROCESS_UPLOAD_FILE:
    "react-table-status-retry_queue_process_upload_file",
  RETRY_QUEUE_PROCESS_CALL_NEXT_STEP:
    "react-table-status-retry_queue_process_call_next_step",
  SET_EXPIRATION_DATE_BEFORE_VALIDATION:
    "react-table-status-set_expiration_date_before_validation",
  ACTIVITY_REOPENED: "react-table-status-activity_reopened",
  CALL_EXTERNAL_API: "react-table-status-call-external-api",
  FILE_SEND_TO_ANALYZE: "react-table-status-file-send-to-analyze",
  COMPLETE_ATV_FIELDGLASS: "react-table-status-complete-atv-fieldglass",
  RESET_ACTIVITY: "react-table-status-reset-activity",
  RETRY_QUEUE_CREATE: "react-table-status-retry-queue-create",
  RETRY_QUEUE_PROCESS_REOPEN_ATV:
    "react-table-status-retry-queue-process-reopen-atv",
  RETRY_QUEUE_PROCESS_REOPEN_ATV_SUCCESS:
    "react-table-status-retry-queue-process-reopen-atv-success",
  WORK_ITEM_CREATED: "react-table-status-work-item-created",
  FILE_DOWNLOAD: "react-table-status-file-download",
  "ACTIVITY IN REVIEW": "react-table-status-activity-in-review",
};

export type ISubjectStatusLogSystem =
  | "DOWNLOAD_FILE_FROM_FIELDGLASS"
  | "UPLOAD_FILE_FROM_UVERIFY"
  | "DOCUMENT_EXTRACTION_COMPLETED_SUCCESS"
  | "DOCUMENT_EXTRACTION_COMPLETED_FAIL"
  | "ANALISYS_COMPLETED_SUCCESS"
  | "ANALISYS_COMPLETED_FAIL"
  | "MANUAL_APPROVAL"
  | "MANUAL_REJECTION"
  | "MANUAL_APPROVAL_BY_SUPERUSER"
  | "MANUAL_REJECTION_BY_SUPERUSER"
  | "DOWNLOAD_FILE_FROM_UVERIFY"
  | "COMPLETE_ACTIVITY_ITEM_FIELDGLASS"
  | "REOPEN_ACTIVITY_ITEM_FIELDGLASS"
  | "EMAIL_SENT"
  | "SUPPLIER_DOWNLOAD"
  | "SUPPLIER_DOWNLOADED"
  | "WAITING_FOR_DOWNLOAD"
  | "REJECTED"
  | "APPROVED"
  | "WAITING_FOR_APPROVAL"
  | "PREPARING_FOR_PROCESS"
  | "MANUAL_VALIDATION"
  | "WAITING_DOCUMENTS"
  | "FINISHED"
  | "WAITING_PROCESS"
  | "VALIDATION_PENDING"
  | "NOT_HOMOLOGATED"
  | "SUPPLIER_UPLOADING_DOCUMENTS"
  | "NOT_HOMOLOGATED_BR"
  | "RESET_VALIDATION_FIELDS"
  | "CHANGE_STATUS"
  | "SUPPLIER_DOWNLOAD"
  | "DELETE_ATTACHMENT"
  | "WORKFLOW_INITIATED"
  | "APPROVED"
  | "FINISHED"
  | "MANUAL_VALIDATION"
  | "PREPARING_FOR_PROCESS"
  | "REJECTED"
  | "SUPPLIER_DOWNLOADED"
  | "WAITING_FOR_APPROVAL"
  | "WAITING_FOR_DOWNLOAD"
  | "WAITING_PROCESS"
  | "SUPPLIER_UPLOADING_DOCUMENTS"
  | "FILE_UPLOADED"
  | "MANUAL_REOPEN_BY_SUPERUSER"
  | "FILE_UPLOADED_AZURE"
  | "DOCUMENT_DEACTIVATED"
  | "AUTOMATIC_APPROVAL"
  | "AUTOMATIC_REJECTION"
  | "SEND_COMPLETE_QUEUE_PROCESS"
  | "RETRY_QUEUE_PROCESS_COMPLETE_ATV"
  | "RETRY_QUEUE_PROCESS_UPLOAD_FILE"
  | "RETRY_QUEUE_PROCESS_CALL_NEXT_STEP"
  | "SET_EXPIRATION_DATE_BEFORE_VALIDATION"
  | "ACTIVITY_REOPENED"
  | "CALL_EXTERNAL_API"
  | "FILE_SEND_TO_ANALYZE"
  | "COMPLETE_ATV_FIELDGLASS"
  | "RESET_ACTIVITY"
  | "RETRY_QUEUE_CREATE"
  | "RETRY_QUEUE_PROCESS_REOPEN_ATV"
  | "WORK_ITEM_CREATED"
  | "FILE_DOWNLOAD"
  | "RETRY_QUEUE_PROCESS_REOPEN_ATV_SUCCESS"
  | "ACTIVITY IN REVIEW";

export enum EUsersStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  INVITE_SENT = "Invite Sent",
  INVITE_EXPIRED = "Invite Expired",
}

export type IMessagesError =
  | "ERR_VALIDATE"
  | "ERR_SAVE"
  | "ERR_DELETING_ATTACHMENT"
  | "ERR_MANUAL_VALIDATION"
  | "ERR_UPLOADING_FAILED"
  | "ERR_DOWNLOAD_FAILED"
  | "ERR_DOWNLOAD_STEP_FAILED"
  | "ERR_REOPEN"
  | "ERR_GETTING_REPORTS"
  | "ERR_FILES_NOT_FOUND"
  | "ERR_REPORT"
  | "ERR_PROCESS"
  | "ERR_UPDATE_SENSITIVE_DATA"
  | "CPF is invalid"
  | "Error when try create worker in fieldglass"
  | "Newly Created Worker"
  | "Worker is active"
  | "Forbidden"
  | "Renavam is invalid"
  | "WORKITEMS_NOT_FOUND"
  | "ERR_REVIEW"
  //
  | "ERR_VALIDATE_DEFAULT"
  | "ERR_SAVE_DEFAULT"
  | "ERR_DELETING_ATTACHMENT_DEFAULT"
  | "ERR_MANUAL_VALIDATION_DEFAULT"
  | "ERR_UPLOADING_FAILED_DEFAULT"
  | "ERR_DOWNLOAD_FAILED_DEFAULT"
  | "ERR_DOWNLOAD_STEP_FAILED_DEFAULT"
  | "ERR_REOPEN_DEFAULT"
  | "ERR_GETTING_REPORTS_DEFAULT"
  | "ERR_FILES_NOT_FOUND_DEFAULT"
  | "ERR_PROCESS_DEFAULT"
  | "ERR_PROCESS_ACTIVITY_DEFAULT"
  | "ERR_REPORT_DEFAULT"
  | "ERR_UPDATE_SENSITIVE_DATA_DEFAULT"
  | "ERR_CREATE_WORKER"
  | "ERR_TICKET_DEFAULT"
  | "ERR_REVIEW_DEFAULT";

export const MessagesErrorEnum = {
  ERR_VALIDATE: "default-error-validate",
  ERR_SAVE: "default-error-save",
  ERR_DELETING_ATTACHMENT: "default-error-deleting-attachment",
  ERR_MANUAL_VALIDATION: "default-error-manual-validation",
  ERR_UPLOADING_FAILED: "default-error-uploading-failed",
  ERR_DOWNLOAD_FAILED: "default-error-download-failed",
  ERR_DOWNLOAD_STEP_FAILED: "default-error-download-step-failed",
  ERR_REOPEN: "default-error-reopen",
  ERR_GETTING_REPORTS: "default-error-getting-reports",
  ERR_FILES_NOT_FOUND: "default-error-files-not-found",
  ERR_REPORT: "default-error-report",
  ERR_PROCESS: "default-error-process",
  ERR_UPDATE_SENSITIVE_DATA: "default-update-sensitive-data",
  "CPF is invalid": "default-error-cpf-invalid",
  "Error when try create worker in fieldglass":
    "default-error-create-worker-fieldglass",
  "Newly Created Worker": "default-error-newly-created-worker",
  "Worker is active": "default-error-worker-active",
  Forbidden: "default-error-forbidden",
  "Renavam is invalid": "default-error-renavam-invalid",
  ERR_REVIEW: "default-error-review",
  //
  ERR_VALIDATE_DEFAULT: "default-error-validate",
  ERR_SAVE_DEFAULT: "default-error-save",
  ERR_DELETING_ATTACHMENT_DEFAULT: "default-error-deleting-attachment",
  ERR_MANUAL_VALIDATION_DEFAULT: "default-error-manual-validation",
  ERR_UPLOADING_FAILED_DEFAULT: "default-error-uploading-failed",
  ERR_DOWNLOAD_FAILED_DEFAULT: "default-error-download-failed",
  ERR_DOWNLOAD_STEP_FAILED_DEFAULT: "default-error-download-step-failed",
  ERR_REOPEN_DEFAULT: "default-error-reopen",
  ERR_GETTING_REPORTS_DEFAULT: "default-error-getting-reports",
  ERR_FILES_NOT_FOUND_DEFAULT: "default-error-files-not-found",
  ERR_REPORT_DEFAULT: "default-error-report",
  ERR_PROCESS_DEFAULT: "default-error-process",
  ERR_PROCESS_ACTIVITY_DEFAULT: "default-error-process-activity",
  ERR_UPDATE_SENSITIVE_DATA_DEFAULT: "default-update-sensitive-data",
  ERR_CREATE_WORKER: "default-error-create-worker",
  WORKITEMS_NOT_FOUND: "default-error-workitems-not-found",
  "Worker start date and End Date are required":
    "worker-start-end-date-required",
  "Start Date must be between the Start Date and End Dates of the Statement of Work":
    "start-dates-not-between-dates-from-sow",
  "End Date must be between the Start Date and End Dates of the Statement of Work":
    "end-dates-not-between-dates-from-sow",
  ERR_TICKET_DEFAULT: "default-error-ticket",
  ERR_REVIEW_DEFAULT: "default-error-review",
};

export const VisibleActivityEnum: {
  MONTHLY: "MONTHLY";
  FULL: "FULL";
} = {
  MONTHLY: "MONTHLY",
  FULL: "FULL",
};

export interface IRenderToastUnique {
  toastId: string;
  message: string;
  type: "info" | "success" | "warning" | "error" | "loading";
  // typeUpdate?: "INFO" | "SUCCESS" | "WARNING" | "ERROR" | "DEFAULT";
  options?: ToastOptions;
}

export const FilterSowStatusEnum = [
  "Approved",
  "Closed",
  "Declined",
  "Draft",
  "Pending Approval",
  "Pending Response",
  "Rejected",
  "Pending Supplier Review",
  "Pending Buyer Review",
];

export const FilterWorkerStatusEnum = [
  "Active",
  "Inactive",
  "Closed",
  "Pending",
];

export enum ActivityItemStatusEnumTagFilter {
  APPROVED = "Approved",
  REJECTED = "Rejected",
  MANUAL_VALIDATION = "MANUAL_VALIDATION",
  VALIDATION_PENDING = "VALIDATION PENDING",
  WAITING_FOR_DOWNLOAD = "WAITING_FOR_DOWNLOAD",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  WAITING_DOCUMENTS = "WAITING_DOCUMENTS",
  SUPPLIER_DOWNLOADED = "SUPPLIER_DOWNLOADED",
  SUPPLIER_DOWNLOAD = "SUPPLIER_DOWNLOAD",
  UPLOADING_DOCUMENTS = "Uploading Documents",
  UPLOADING_DOCUMENTS_BUYER = "UPLOADING_DOCUMENTS_BUYER",
  UPLOADING_DOCUMENTS_SUPPLIER = "UPLOADING_DOCUMENTS_SUPPLIER",
  READ_ONLY = "READ_ONLY",
}

export enum ActivityItemValidationStatusEnumTagFilter {
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  CANCELED = "Canceled",
  WAITING_FOR_UPDATE = "WAITING_FOR_UPDATE",
}

export const ConsolidatedWorkerStatusEnum = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED",
  PENDING: "PENDING",
};

// Função para obter as chaves de um enum como um array
export function getEnumKeys<E>(enumObj: E): (keyof E)[] {
  return Object.keys(enumObj).filter((key) =>
    isNaN(Number(key))
  ) as (keyof E)[];
}
